import { defineApi } from '@/utils/fetch';

import type {
    TGetBannersParams,
    IGetBannersResponse,
    TGetTopTrendingParams,
    IGetTopTrendingResponse,
    TGetWeeklyFeaturedParams,
    IGetWeeklyFeaturedResponse,
} from './typings';

export const HomeApi = {
    getBanners: defineApi<TGetBannersParams, IGetBannersResponse>({
        url: '/home/banners/v1',
        method: 'GET',
    }),

    getTopTrending: defineApi<TGetTopTrendingParams, IGetTopTrendingResponse>({
        url: '/home/top-trending/v1',
        method: 'GET',
    }),

    getWeeklyFeatured: defineApi<TGetWeeklyFeaturedParams, IGetWeeklyFeaturedResponse>({
        url: '/home/weekly-featured/v1',
        method: 'GET',
    }),
};

export * from './typings';
